import * as _ from 'lodash'
import {DimensionType} from "../PA.Core/PA.Core.IF.Hierarchy";
import {ICell, IDimensionCompositeKeys, IDimensionDistinctKeys} from "./PA.HyperRectangle.IF";


export class CellUtils
{



    static getDistinctKeys(arrDimensionTypes: DimensionType[], arrCells: ICell[]): IDimensionDistinctKeys
    {
        let dctValues: {[dimTypeId: string]: {[key:string]: string}} = {}

        _.forEach(arrDimensionTypes, (aType) => {
            dctValues[aType] = {}
        })

        _.forEach(arrCells, (aCell: ICell) => {
            _.forEach(arrDimensionTypes, (aType) => {
                let keyValue = aCell.getKey(aType)
                if(!_.isEmpty(keyValue))
                    return

                if(!(keyValue in dctValues[aType]))
                    dctValues[aType][keyValue] = keyValue
            })
        })


        let returnValue: IDimensionDistinctKeys = {}

        _.forEach(dctValues, (val, key) => {
            returnValue[key] = _.values(val)
        })

        return returnValue
    }

    static getCompositeKeys(arrDimensionTypes: DimensionType[], arrCells: ICell[],
                            bIncludeEmptyValue?: boolean, sEmptyValue?: string): IDimensionCompositeKeys
    {
        let returnValue: IDimensionCompositeKeys = {}
        _.forEach(arrCells, (aCell) => {

            let currentNode = returnValue
            for(let idx in arrDimensionTypes){
                let aDimType = arrDimensionTypes[idx]
                let idx_n = _.toNumber(idx)
                let bLast = (idx_n == (arrDimensionTypes.length - 1))

                let keyValue = aCell.getKey(aDimType)
                if(_.isEmpty(keyValue)){
                    if(bIncludeEmptyValue)
                        keyValue = sEmptyValue
                    else
                        break; // don't continue, go to next cell
                }

                if(keyValue in currentNode) {
                    // @ts-ignore
                    currentNode = currentNode[keyValue]
                    continue
                }

                if(bLast)
                    currentNode[keyValue] = keyValue
                else
                    currentNode[keyValue] = {}

                // @ts-ignore
                currentNode = currentNode[keyValue]

            }
            //--

        })

        return returnValue

    }


}